import {
    ChatTypes
} from '../ActionTypes/ChatTypes';

class ChatActions {

    static getChatIndex = (payload) => {
        return {
            type: ChatTypes.GET_CHAT_INDEX,
            payload: payload,
        };
    };

    static clearChatIndex = () => {
        return {
            type: ChatTypes.CLEAR_CHAT_INDEX,
        };
    };

    static getMessageList = (payload) => {
        return {
            type: ChatTypes.GET_MESSAGE_LIST,
            payload: payload,
        };
    };

    static updateMessageList = (payload) => {
        return {
            type: ChatTypes.UPDATE_MESSAGE_LIST,
            payload: payload,
        };
    };

    static clearMessageList = () => {
        return {
            type: ChatTypes.CLEAR_MESSAGE_LIST,
        };
    };

}

export default ChatActions;
